import apiClient, { extractData } from "./client";

export async function getBranches(params = {}) {
  const response = await apiClient.get("/branches", { params });
  return extractData(response);
}

export async function getBranch(id) {
  const response = await apiClient.get(`/branches/${id}`);
  return extractData(response);
}

export async function createBranch(data) {
  const response = await apiClient.post("/branches", data);
  return extractData(response);
}

export async function updateBranch(id, data) {
  const response = await apiClient.patch(`/branches/${id}`, data);
  return extractData(response);
}
